// extracted by mini-css-extract-plugin
module.exports = {"AddCommentHolder":"AddComment_AddCommentHolder__2PLsO","BtnHolder":"AddComment_BtnHolder__1vLoU","CodeHolder":"AddComment_CodeHolder__3ujlD"};